import { useState, useEffect } from "react";
import { useAddNewUserMutation } from "./usersApiSlice";
import { useNavigate } from "react-router-dom";
import { ROLES } from "../../config/roles";
import useTitle from "../../hooks/useTitle";

import NewRadnikuOrganizacijiForm from "./NewRadnikuOrganizacijiForm";
import UserModalOrganizacija from "./UserModalOrganizacija";

import UserPozicija from "./UserPozicija";
import {
  selectPositionsIds,
  selectPositions,
  resetPositions,
} from "../users/userPositionDataSlice";
import { useSelector, useDispatch } from "react-redux";

const NewUserForm = ({ onClose }) => {
  useTitle("Dodaj korisnika");

  const positionIds = useSelector(selectPositionsIds);
  const positions = useSelector(selectPositions);
  const dispatch = useDispatch();

  //User data
  const [name, setName] = useState("");
  const [validName, setValidName] = useState(false);

  const [lastName, setLastName] = useState("");
  const [validLastName, setIsLastNameValid] = useState(false);

  const [username, setUsername] = useState("");
  const [validUsername, setValidUsername] = useState(false);

  //Make password matching function
  const [password, setPassword] = useState("");
  const [validPassword, setValidPassword] = useState(false);

  const [password2, setPassword2] = useState("");
  const [validPassword2, setValidPassword2] = useState(false);

  const [jmbg, setJmbg] = useState("");
  const [validJmbg, setValidJmbg] = useState(false);

  const [plata, setPlata] = useState("");
  const [validPlata, setValidPlata] = useState(false);

  const [roles, setRoles] = useState([]);

  const [hasErrors, setHasErrors] = useState();

  const [newUserFormSection, setNewUserFormSection] = useState(false);

  //Modali
  const [isModalOpenSuccess, setIsModalOpenSuccess] = useState(false);
  const [isModalDupli, setIsModalDupli] = useState(false);
  const [isModalPassword, setIsModalPassword] = useState(false);

  //Za otvaranje radnikapozicija modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  //Za otvaranje dodaj poziciju u organizaciji
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = () => {
    handleCloseModal();
  };

  //ZA RADIO GROUP
  const [selectedOptionStatus, setSelectedOptionStatus] = useState("Aktivan");
  const [selectedOptionValuta, setSelectedOptionValuta] = useState("RSD");

  const handleOptionChangeStatus = (e) => {
    setSelectedOptionStatus(e.target.value);
  };

  const handleOptionChangeValuta = (e) => {
    setSelectedOptionValuta(e.target.value);
  };

  //User from
  const openNewUserFormSection = () => setNewUserFormSection(true);

  //Modal
  const openModalSuccess = () => setIsModalOpenSuccess(true);
  const openModalDupli = () => setIsModalDupli(true);
  const openModalPassword = () => setIsModalPassword(true);
  const closeModalSuccess = () => setIsModalOpenSuccess(false);
  const closeModalDupli = () => setIsModalDupli(false);
  const closeModalPassword = () => setIsModalPassword(false);

  const navigate = useNavigate();

  const [addNewUser, { isLoading, isSuccess, isError, error }] =
    useAddNewUserMutation();

  //Error fealds
  const [fieldErrors, setFieldErrors] = useState({
    name: false,
    lastName: false,
    // username: false,
    // password: false,
    // password2: false,
    // address: false,
    // phone: false,
    // roles: false
  });

  // useEffect(() => {
  //     if (!isError) {
  //         setName('');
  //         setLastName('');
  //         setUsername('');
  //         setPassword('');
  //         setPassword2('');
  //         setAddress('');
  //         setPhone('');
  //         setRoles([]);
  //         // openModalSuccess();
  //     }
  // }, [isSuccess, navigate])

  //Setters
  const onNameChanged = (e) => {
    setName(e.target.value);
    if (fieldErrors.name) setFieldErrors((prev) => ({ ...prev, name: false }));
  };

  const onLastNameChanged = (e) => {
    setLastName(e.target.value);
    if (fieldErrors.lastName)
      setFieldErrors((prev) => ({ ...prev, lastName: false }));
  };

  const onUsernameChanged = (e) => {
    setUsername(e.target.value);
    if (fieldErrors.username)
      setFieldErrors((prev) => ({ ...prev, username: false }));
  };

  const onPasswordChanged = (e) => {
    setPassword(e.target.value);
    if (fieldErrors.password)
      setFieldErrors((prev) => ({ ...prev, password: false }));
  };

  const onPasswordChanged2 = (e) => {
    setPassword2(e.target.value);
    if (fieldErrors.password2)
      setFieldErrors((prev) => ({ ...prev, password2: false }));
  };

  const onJmbgChanged = (e) => {
    setJmbg(e.target.value);
    if (fieldErrors.jmbg) setFieldErrors((prev) => ({ ...prev, jmbg: false }));
  };

  const onPlataChanged = (e) => {
    setPlata(e.target.value);
    if (fieldErrors.plata)
      setFieldErrors((prev) => ({ ...prev, plata: false }));
  };

  const onRolesChanged = (e) => {
    const values = Array.from(
      e.target.selectedOptions, //HTMLCollection
      (option) => option.value
    );
    setRoles(values);

    if (e.target.value === "Editor" || e.target.value === "Admin") {
      setNewUserFormSection(true);
    } else {
      setNewUserFormSection(false);
    }
  };

  const options = Object.values(ROLES)
    .filter((role) => role !== "Klijent")
    .map((role) => {
      return (
        <option key={role} value={role}>
          {role}
        </option>
      );
    });

  useEffect(() => {
    // Set the first non-Klijent role as the default
    const firstRole = Object.values(ROLES).find((role) => role !== "Klijent");
    setRoles(firstRole);
  }, []);

  // let checkPassword = (password1, password2) => {
  //     if (!password1.trim() || !password2.trim()) {
  //         return false;
  //     }

  //     return password1 === password2;
  // }

  let chekPassword = (password1, password2) => {
    return password1 == password2;
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  //OVDE SALJEM
  const handleConfirmSuccess = async () => {
    closeModalSuccess();
    onClose();
  };

  //Provera
  const canSave =
    [
      roles.length,
      validUsername,
      validPassword,
      validPassword2,
      validName,
      validLastName,
      validJmbg,
      validPlata,
    ].every(Boolean) && !isLoading;

  // const onSaveUserClicked = async (e) => {
  //     e.preventDefault();

  //     // Validation logic BOJE...
  //     const newFieldErrors = {
  //         name: name.trim() === '',
  //         lastName: lastName.trim() === '',
  //         username: username.trim() === '',
  //         password: password.trim() === '',
  //         password2: password2.trim() === '',
  //         jmbg: jmbg.trim() === '',
  //         plata: plata === '',
  //     };

  //     setFieldErrors(newFieldErrors);
  //     const hasFormErrors = Object.values(newFieldErrors).some(error => error);
  //     setHasErrors(hasFormErrors);

  //     if (!hasFormErrors) {
  //         if (!chekPassword(password, password2)) {
  //             openModalPassword();
  //             return; // Exit early if passwords don't match
  //         }

  //         try {
  //             // Attempt to add new user
  //             let response = await addNewUser({ name, lastName, username, password, jmbg, roles, plata, status: selectedOptionStatus,valuta: selectedOptionValuta }).unwrap();
  //             console.log('User added successfully:', response);

  //             // Call openModalSuccess if the request succeeds
  //             openModalSuccess();
  //         } catch (err) {
  //             console.error('Failed to add user:', err);
  //             // Handle error case
  //             openModalDupli();
  //         }
  //     }
  // };

  const onSaveUserClicked = async (e) => {
    e.preventDefault();

    // Validation logic BOJE...
    const newFieldErrors = {
      name: name.trim() === "",
      lastName: lastName.trim() === "",
      // username: username.trim() === '',
      // password: password.trim() === '',
      // password2: password2.trim() === '',
      jmbg: jmbg.trim() === "",
      plata: plata === "",
    };

    setFieldErrors(newFieldErrors);
    const hasFormErrors = Object.values(newFieldErrors).some((error) => error);
    setHasErrors(hasFormErrors);

    if (!hasFormErrors) {
      if (!chekPassword(password, password2)) {
        openModalPassword();
        return;
      }

      try {
        let response = await addNewUser({
          name,
          lastName,
          username,
          password,
          jmbg,
          roles,
          plata,
          status: selectedOptionStatus,
          valuta: selectedOptionValuta,
          pozicijeUsera: positions,
        }).unwrap();
        console.log("User added successfully:", response);
        //Trebalo bi da se sa isSuccess da se saceka sa servera
        dispatch(resetPositions());

        openModalSuccess();
      } catch (err) {
        console.error("Failed to add user:", err);
        openModalDupli();
      }
    }

    //Samo resetuje sve pozicije iz redux slajsa/stejta
    // dispatch(resetPositions())
  };

  let newUserForm = (
    <>
      <div className="sm:col-span-3">
        {/* V1 */}
        <label
          htmlFor="username"
          className="block text-sm font-medium leading-6 text-gray-900"
        >
          Korisničko ime
        </label>
        {/* <span className={`${isError ? 'text-red-500' : ''}`}>{error?.data?.message}</span> */}

        {/* V2 */}
        {/* <div className="flex items-center space-x-2">
                    <label htmlFor="username" className="text-sm font-medium leading-6 text-gray-900">
                        Korisničko ime
                    </label>
                    <span className={`${isError ? 'text-red-500' : ''}`}>
                        {error?.data?.message}
                    </span>
                </div> */}

        {/* V3 */}
        {/* <div className="flex items-center space-x-2">
                    <label
                        htmlFor="username"
                        className={`text-sm font-medium leading-6 text-gray-900 ${isError ? 'underline text-red-500' : ''}`}
                        style={isError ? { textDecoration: 'underline', textDecorationColor: 'red' } : {}}
                    >
                        Korisničko ime
                    </label>
                    <span className={`${isError ? 'text-red-500' : ''}`}>
                        {error?.data?.message}
                    </span>
                </div> */}

        <div className="mt-1">
          <input
            type="text"
            name="username"
            id="username"
            value={username}
            onChange={onUsernameChanged}
            autoComplete="username"
            className={`block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
              fieldErrors.username
                ? "bg-red-100 ring-red-500 focus:ring-red-500"
                : "ring-gray-300 focus:ring-indigo-600"
            }`}
          />
        </div>
      </div>

      <div className="sm:col-span-3">
        <label
          htmlFor="password"
          className="block text-sm font-medium leading-6 text-gray-900"
        >
          Lozinka
        </label>
        <div className="mt-1">
          <input
            type="password"
            name="password"
            id="password"
            value={password}
            onChange={onPasswordChanged}
            autoComplete="password"
            className={`block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
              fieldErrors.password
                ? "bg-red-100 ring-red-500 focus:ring-red-500"
                : "ring-gray-300 focus:ring-indigo-600"
            }`}
          />
        </div>
      </div>

      <div className="sm:col-span-3">
        <label
          htmlFor="password2"
          className="block text-sm font-medium leading-6 text-gray-900"
        >
          Ponovi lozinku
        </label>
        <div className="mt-1">
          <input
            type="password"
            name="password2"
            id="password2"
            value={password2}
            onChange={onPasswordChanged2}
            autoComplete="password2"
            className={`block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
              fieldErrors.password2
                ? "bg-red-100 ring-red-500 focus:ring-red-500"
                : "ring-gray-300 focus:ring-indigo-600"
            }`}
          />
        </div>
      </div>
    </>
  );

  function getRandomWord(length = 5) {
    const letters = "abcdefghijklmnopqrstuvwxyz";
    let word = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * letters.length);
      word += letters[randomIndex];
    }
    return word;
  }

  let tableContentPozicije = positionIds.map((pozicijaId) => (
    <UserPozicija key={getRandomWord()} pozicijaId={pozicijaId} />
  ));

  // let pozicijeReduxContent = (

  // )

  // const errClass = isError ? "text-red" : "text-black"

  //TailwindConetent
  const tailwindContent = (
    <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
      <div className="bg-white shadow-sm ring-gray-900/5 sm:rounded md:col-span-3">
        {/* Ovaj je za border */}
        <div className="px-3 py-3 sm:p-3">
          {" "}
          <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-3">
            {/* Error message */}
            {/* <p className={errClass}>{error?.data?.message}</p> */}

            <div className="sm:col-span-3">
              <label
                htmlFor="last-name"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Ime
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="last-name"
                  id="last-name"
                  value={name}
                  onChange={onNameChanged}
                  autoComplete="family-name"
                  className={`block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
                    fieldErrors.name
                      ? "bg-red-100 ring-red-500 focus:ring-red-500"
                      : "ring-gray-300 focus:ring-indigo-600"
                  }`}
                />
              </div>
            </div>

            <div className="sm:col-span-3">
              <label
                htmlFor="last-name"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Prezime
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="last-name"
                  id="last-name"
                  value={lastName}
                  onChange={onLastNameChanged}
                  autoComplete="family-name"
                  className={`block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
                    fieldErrors.lastName
                      ? "bg-red-100 ring-red-500 focus:ring-red-500"
                      : "ring-gray-300 focus:ring-indigo-600"
                  }`}
                />
              </div>
            </div>

            <div className="sm:col-span-2">
              <label
                htmlFor="role"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Pozicija
              </label>
              <div className="mt-1">
                {/* Throws error because value is not scalar... */}
                <select
                  id="role"
                  name="role"
                  autoComplete="role"
                  value={roles}
                  onChange={onRolesChanged}
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                >
                  {options}
                </select>
              </div>
            </div>

            {newUserFormSection && newUserForm}

            <div className="sm:col-span-3">
              <label
                htmlFor="street-jmbg"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Jmbg
              </label>
              <div className="mt-1">
                <input
                  type="number"
                  name="street-jmbg"
                  id="street-jmbg"
                  value={jmbg}
                  onChange={onJmbgChanged}
                  autoComplete="street-jmbg"
                  className={`block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
                    fieldErrors.jmbg
                      ? "bg-red-100 ring-red-500 focus:ring-red-500"
                      : "ring-gray-300 focus:ring-indigo-600"
                  }`}
                />
              </div>
            </div>

            <div className="sm:col-span-3">
              <label
                htmlFor="plata"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Plata
              </label>
              <div className="mt-1">
                <input
                  type="number"
                  name="plata"
                  id="plata"
                  value={plata}
                  onChange={onPlataChanged}
                  autoComplete="plata"
                  className={`block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
                    fieldErrors.plata
                      ? "bg-red-100 ring-red-500 focus:ring-red-500"
                      : "ring-gray-300 focus:ring-indigo-600"
                  }`}
                />
              </div>
            </div>

            {/* <br /> */}

            {/* OK */}
            {/* <div className="sm:col-span-3">
                                <fieldset>
                                <label className="text-sm font-semibold leading-6 text-gray-900">Status: </label>
                                <div className="mt-3 space-y-6 sm:flex sm:items-center sm:space-x-1 sm:space-y-0">
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            value="Aktivan"
                                            checked={selectedOptionStatus === 'Aktivan'}
                                            onChange={handleOptionChangeStatus}
                                            className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                        />
                                        <label htmlFor="Aktivan" className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900">
                                            Aktivan
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            value="Neaktivan"
                                            checked={selectedOptionStatus === 'Neaktivan'}
                                            onChange={handleOptionChangeStatus}
                                            className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                        />
                                        <label htmlFor="Neaktivan" className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900">
                                            Neaktivan
                                        </label>
                                    </div>
                                </div>
                            </fieldset>
                        </div> */}

            {/* <br/> */}

            {/* OK */}
            {/* <div className="sm:col-span-3">
                                <fieldset>
                                <label className="text-sm font-semibold leading-6 text-gray-900">Valuta: </label>
                                <div className="mt-3 space-y-6 sm:flex sm:items-center sm:space-x-1 sm:space-y-0">
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            value="EUR"
                                            checked={selectedOptionValuta === 'EUR'}
                                            onChange={handleOptionChangeValuta}
                                            className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                        />
                                        <label htmlFor="EUR" className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900">
                                            EUR
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            value="RSD"
                                            checked={selectedOptionValuta === 'RSD'}
                                            onChange={handleOptionChangeValuta}
                                            className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                        />
                                        <label htmlFor="RSD" className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900">
                                            RSD
                                        </label>
                                    </div>
                                </div>
                            </fieldset>
                        </div> */}

            <div className="sm:col-span-3">
              <fieldset className="flex items-center space-x-3">
                <label className="text-sm font-semibold leading-6 text-gray-900">
                  Status:{" "}
                </label>
                <div className="space-y-6 sm:flex sm:items-center sm:space-x-1 sm:space-y-0">
                  <div className="flex items-center">
                    <input
                      type="radio"
                      value="Aktivan"
                      checked={selectedOptionStatus === "Aktivan"}
                      onChange={handleOptionChangeStatus}
                      className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                    />
                    <label
                      htmlFor="Aktivan"
                      className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900"
                    >
                      Aktivan
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      value="Neaktivan"
                      checked={selectedOptionStatus === "Neaktivan"}
                      onChange={handleOptionChangeStatus}
                      className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                    />
                    <label
                      htmlFor="Neaktivan"
                      className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900"
                    >
                      Neaktivan
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="sm:col-span-3">
              <fieldset className="flex items-center space-x-3">
                <label className="text-sm font-semibold leading-6 text-gray-900">
                  Valuta:{" "}
                </label>
                <div className="space-y-6 sm:flex sm:items-center sm:space-x-1 sm:space-y-0">
                  <div className="flex items-center">
                    <input
                      type="radio"
                      value="EUR"
                      checked={selectedOptionValuta === "EUR"}
                      onChange={handleOptionChangeValuta}
                      className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                    />
                    <label
                      htmlFor="EUR"
                      className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900"
                    >
                      EUR
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      value="RSD"
                      checked={selectedOptionValuta === "RSD"}
                      onChange={handleOptionChangeValuta}
                      className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                    />
                    <label
                      htmlFor="RSD"
                      className="ml-1 mr-3 block text-sm font-medium leading-6 text-gray-900"
                    >
                      RSD
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>

            {/* <div className="sm:col-span-3">
                            <table className="w-full border border-gray-300">
                                <tbody>
                                    <tr className="border-b border-gray-300">
                                        <td className="align-top p-2 border-r border-gray-300">
                                            <label className="text-sm font-semibold leading-6 text-gray-900">Status: </label>
                                        </td>
                                        <td className="p-2">
                                            <div className="flex items-center">
                                                <div className="flex items-center border-r border-gray-300 pr-2">
                                                    <input
                                                        type="radio"
                                                        value="Aktivan"
                                                        checked={selectedOptionStatus === 'Aktivan'}
                                                        onChange={handleOptionChangeStatus}
                                                        className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                                    />
                                                    <label htmlFor="Aktivan" className="ml-1 block text-sm font-medium leading-6 text-gray-900">
                                                        Aktivan
                                                    </label>
                                                </div>
                                                <div className="flex items-center pl-2">
                                                    <input
                                                        type="radio"
                                                        value="Neaktivan"
                                                        checked={selectedOptionStatus === 'Neaktivan'}
                                                        onChange={handleOptionChangeStatus}
                                                        className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                                    />
                                                    <label htmlFor="Neaktivan" className="ml-1 block text-sm font-medium leading-6 text-gray-900">
                                                        Neaktivan
                                                    </label>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="align-top p-2 border-r border-gray-300">
                                            <label className="text-sm font-semibold leading-6 text-gray-900">Valuta: </label>
                                        </td>
                                        <td className="p-2">
                                            <div className="flex items-center">
                                                <div className="flex items-center border-r border-gray-300 pr-2">
                                                    <input
                                                        type="radio"
                                                        value="EUR"
                                                        checked={selectedOptionValuta === 'EUR'}
                                                        onChange={handleOptionChangeValuta}
                                                        className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                                    />
                                                    <label htmlFor="EUR" className="ml-1 block text-sm font-medium leading-6 text-gray-900">
                                                        EUR
                                                    </label>
                                                </div>
                                                <div className="flex items-center pl-2">
                                                    <input
                                                        type="radio"
                                                        value="RSD"
                                                        checked={selectedOptionValuta === 'RSD'}
                                                        onChange={handleOptionChangeValuta}
                                                        className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600"
                                                    />
                                                    <label htmlFor="RSD" className="ml-1 block text-sm font-medium leading-6 text-gray-900">
                                                        RSD
                                                    </label>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> */}

            <div className="sm:col-span-3">
              {/* <label htmlFor="plata" className="block text-sm font-medium leading-6 text-gray-900">Plata</label> */}
              <div className="mt-1">
                <button
                  onClick={handleOpenModal}
                  className="rounded bg-blue-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                >
                  Dodaj organizaciju
                </button>
              </div>
            </div>

            {Object.keys(positions).length !== 0 ? (
              <div className="sm:col-span-3">
                <div className="flow-root">
                  <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-1 align-middle sm:px-6 lg:px-8">
                      <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded">
                        <table className="min-w-full divide-y divide-gray-300">
                          <thead className="bg-gray-300">
                            <tr>
                              <th
                                scope="col"
                                className="py-1 border-r pl-4 pr-3 text-left text-sm font-semibold text-gray-900"
                              >
                                Organizacija
                              </th>
                              <th
                                scope="col"
                                className="py-1 px-3 border-r text-left text-sm font-semibold text-gray-900"
                              >
                                Pozicija
                              </th>
                              <th
                                scope="col"
                                className="py-1 px-3 border-r text-left text-sm font-semibold text-gray-900"
                              >
                                Sektor
                              </th>
                              <th
                                scope="col"
                                className="py-1 px-3 border-r text-left text-sm font-semibold text-gray-900"
                              >
                                Kontrole
                              </th>
                              {/* <th scope="col" className="px-3 border-r py-3.5 text-left text-sm font-semibold text-gray-900">Tip ugovora</th>
                                                            <th scope="col" className="px-3 border-r py-3.5 text-left text-sm font-semibold text-gray-900">Kontrole</th> */}
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200 bg-white">
                            {tableContentPozicije}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>

        <div className="flex items-center justify-end gap-x-2 border-t border-gray-900/10 px-2 py-2 sm:px-2">
          <button
            onClick={onSaveUserClicked}
            className="rounded bg-blue-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
          >
            Sačuvaj
          </button>
        </div>

        {/* <div className="flex items-center justify-end gap-x-2 border-t border-gray-900/10 px-2 py-2 sm:px-2">
                    <button onClick={()=>addNewUser({name: "Hello"})} className="rounded bg-blue-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">Test</button>
                </div> */}

        {/* <div>
                    <h1>List of Items</h1>
                    <ul>
                        {positions.map((item) => (
                        <li key={item.organizacijaId}>
                            <p>Organizacija ID: {item.organizacijaId}</p>
                            <p>Fix Ugovoren: {item.fixUgovoren}</p>
                            <p>Selected Option Kafa: {item.selectedOptionKafa}</p>
                            <p>Selected Option Dnevnica: {item.selectedOptionDnevnica}</p>
                        </li>
                        ))}
                    </ul>
                </div> */}
      </div>{" "}
      {/* Ovaj je za border */}
    </div>
  );

  return (
    <>
      {/* template za svaku komponentu */}
      <div className="">
        {/* <header className="mb-3">
                    <div className="">
                        <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">Novi korisnik</h1>
                    </div>
                </header>
                <hr className="border-t border-slate-950" /> */}
        <main className="">
          <div className="">
            {/* <br/> */}
            {tailwindContent}

            {isModalOpenSuccess && (
              <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
                <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                  <div className="mt-3 text-center">
                    {!hasErrors ? (
                      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
                        <svg
                          className="h-6 w-6 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                    ) : (
                      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                        <svg
                          className="h-6 w-6 text-yellow-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                          />
                        </svg>
                      </div>
                    )}

                    <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                      {!hasErrors ? "Obaveštenje" : "Upozorenje"}
                    </h3>

                    <div className="mt-2 px-7 py-3">
                      <p className="text-sm text-gray-500">
                        {!hasErrors
                          ? "Uspešno ste napravili novog korisnika"
                          : "Morate uneti sva polja"}
                      </p>
                    </div>
                    <div className="items-center px-4 py-3">
                      <button
                        onClick={
                          !hasErrors ? handleConfirmSuccess : closeModalSuccess
                        }
                        className={
                          !hasErrors
                            ? "px-4 py-2 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                            : "px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                        }
                      >
                        Uredu
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isModalDupli ? (
              <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
                <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                  <div className="mt-3 text-center">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                      <svg
                        className="h-6 w-6 text-yellow-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                      Upoznorenje
                    </h3>
                    <div className="mt-2 px-7 py-3">
                      {/* <p className="text-sm text-gray-500">Korisnik postoji, unesi novog</p> */}
                      <p className="text-sm text-gray-500">
                        Korisnik postoji, unesite drugi jmbg
                      </p>
                    </div>
                    <div className="items-center px-4 py-3">
                      <button
                        onClick={closeModalDupli}
                        className="px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                      >
                        Ugasi
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {isModalPassword ? (
              <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
                <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                  <div className="mt-3 text-center">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                      <svg
                        className="h-6 w-6 text-yellow-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                      Upoznorenje
                    </h3>
                    <div className="mt-2 px-7 py-3">
                      <p className="text-sm text-gray-500">
                        Loznke se ne poklapaju!
                      </p>
                    </div>
                    <div className="items-center px-4 py-3">
                      <button
                        onClick={closeModalPassword}
                        className="px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                      >
                        Ugasi
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {/* Za otvaranje novog modala - dodavanje pozicije  */}
            <UserModalOrganizacija
              isOpen={isModalOpen}
              onClose={handleCloseModal}
            >
              <NewRadnikuOrganizacijiForm
                onSubmit={handleFormSubmit}
                onClose={handleCloseModal}
              />
            </UserModalOrganizacija>
          </div>
        </main>
      </div>
    </>
  );
};
export default NewUserForm;
